import { AbilityActions, AbilitySubjects } from 'constants/usersPermissions';

export const requiredAbilitiesForUserInfoBlock = [
  { subject: AbilitySubjects.USERS, action: AbilityActions.READ },
  { subject: AbilitySubjects.USERS, action: AbilityActions.CREATE },
  { subject: AbilitySubjects.USERS, action: AbilityActions.UPDATE },
];
